import { FieldValues } from "react-hook-form";

import { Step, StepImage } from "@constants";

const VALID_SERIAL_NUMBER_KEYS = [
  "sensorSerial",
  "moduleSerial",
  "fehSerial",
  "sehSerial",
  "sandwichSerial",
  "mapsaSerial",
  "vtrxSerial",
  "rohSerial",
  "pohSerial",
  "cfBasplateSerial",
];

const IMAGE_KEYS = {
  src: "imageSrc",
  alt: "imageAlt",
} as const;

/**
 * A function to reshape data from React Hook Forms into the correct
 * format for the Steps collection in the database.
 * @param data Data returned from React Hook Forms onSubmit
 * @returns {Partial<Step>} The step object to be submitted to the database.
 */
function transformer(data: FieldValues): Partial<Step> {
  const transformed: Partial<Step> = {
    mainComponentSerial: "",
    moduleId: "",
    comments: "",
  };
  const details: { [x: string]: string | number | boolean } = {};
  const imageData: StepImage = { src: undefined, alt: undefined };

  for (const [key, value] of Object.entries(data)) {
    // Extract imageSrc and imageAlt, then check for serial numbers.
    if (key === IMAGE_KEYS.src) {
      imageData.src = value;
    } else if (key === IMAGE_KEYS.alt) {
      imageData.alt = value;
    }
    // By convention, the first serial number to show up is treated as the
    // identifying serial number for this step.
    else if (
      VALID_SERIAL_NUMBER_KEYS.includes(key) &&
      !(transformed.mainComponentSerial && transformed.moduleId)
    ) {
      transformed.mainComponentSerial = value;
      transformed.moduleId = value;
    } else if (key === "comments" || key === "passed") {
      transformed[key] = value;
    }
    // We can't add images in this way, at least for now
    else if (key != "image" && !key.includes("multipleimage"))
      details[key] = value;
    else if (key.includes("multipleimage")) {
      details[key] = value ? value.length : 0;
    }
  }

  transformed.details = { ...details };
  if (imageData.src) transformed.image = { ...imageData };
  return transformed;
}

export { VALID_SERIAL_NUMBER_KEYS, transformer };
